export default __webpack_public_path__ + "static/media/3.ff7e4f3a.jpg";